






















import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import Popper from 'popper.js';

@Component
export default class SplitButtion extends Vue {
  //buttonプロパティにリダイレクトする
  @Prop() public caption: string;
  @Prop() public icon: string;
  @Prop({default:null}) public sc: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:false}) public disabled: boolean;
  @Prop({default:null}) public perm: string;
  @Prop({default:null}) public buttonStyle: string;

  public eventEnabled :boolean = false;

  public mounted(){
    this.eventEnabled = this.$el.parentElement.classList.contains('cx_appevent_enabled');
  }
  public onClick(){
    this.$emit('click');
  }
  // ****** ポップアップ制御 *******
  public showPopper:boolean = false;
  public popperJS: Popper = null;

  public onShowPopup(){
    this.showPopper = true;
  }

  onDropDown(e:any) {
    if (this.showPopper) {
      this.onHide(e);
    } else {
      this.showPopper = true;
      //境界要素をcx_editorとする
      //popupはoverflow:hiddenが設定されている要素を越えられない。カットされるか領域が拡大されてしまう
      var target = this.$el.closest(".cx_editor");
      this.$nextTick(() => {
        const options = { placement:'bottom-end', modifiers:{preventOverflow:{boundariesElement:target}}};
        this.popperJS = new Popper(this.$refs.dropdown as HTMLElement, this.$refs.popover as HTMLElement, options as any);
        this.popperJS.enableEventListeners();        
        (this.$refs.popover as  HTMLElement).focus();
        (this.$refs.popover  as  HTMLElement).addEventListener('focusout', this.onFocusOut);        
        (this.$refs.popover  as  HTMLElement).addEventListener('click', this.onHide);                
      });
    }
  }
  
  onFocusOut(e:any) {
    //ポップアップもしくはドロップダウンのクリックはフォーカスバック
    if ((this.$refs.popover as HTMLElement).contains(e.relatedTarget) || (this.$refs.dropdown as HTMLElement).contains(e.relatedTarget) ) {
      (this.$refs.popover as  HTMLElement).focus();
      return;
    }
    this.onHide(e);
  }

  onHide(e:any) {
    //return;
    (this.$refs.popover as  HTMLElement).removeEventListener('focusout', this.onFocusOut);    
    (this.$refs.popover as  HTMLElement).removeEventListener('click', this.onHide); 

    this.showPopper = false;
    this.$nextTick(() => {
      if (this.popperJS) {
        this.popperJS.disableEventListeners();
        this.popperJS.destroy();
        this.popperJS = null;
      }
    });
  }
}
